var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: { visible: _vm.$city.isCityModalShown, "allow-close": "" },
      on: {
        "on-close": function($event) {
          return _vm.$city.$emit("city:close")
        }
      }
    },
    [_c("city-search", { attrs: { locally: "" }, on: { choose: _vm.change } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }